import type { Gateway as GraftGateway } from '@graft/nuget-gc.webportals.gateways'

export async function readGatewayModuleVersionInstanceIds(entity: GraftGateway): Promise<string[]> {
  if (typeof entity.get_moduleVersionInstanceIds !== 'function') {
    return []
  }

  try {
    const moduleVersionInstanceIds = await entity.get_moduleVersionInstanceIds()
    return (moduleVersionInstanceIds ?? []).filter((id) => id.trim().length > 0)
  } catch {
    return []
  }
}
